import bugsnag from '@bugsnag/js'
const bugsnagClient = bugsnag({ apiKey: '42189d79b19df0bf3c2eae530d0b9a55', appVersion: '0.1.0' })
bugsnagClient.user = {
    email: localStorage.getItem('okto.opk.pwa.email'),
    device: localStorage.getItem('okto.opk.pwa.deviceHash'),
    validated: sessionStorage.getItem('okto.opk.pwa.validated')
}
export default bugsnagClient